export const API_URL = {
  // ------ START: Auth URL's ------
  sendOtp: '/auth/otp/send',
  sendApplicantOtp: '/auth/otp/applicant/send',
  verifyApplicantsOtp: '/auth/otp/applicant/verify',
  refreshToken: '/auth/token/refresh',
  signin: '/authentication-service/v1/login',
  uploadFile: '/auth/v1/upload-file',

  // ------ START: Recruitment URL's ------
  getAllJobs: '/recruitment/jobs/public',
  getSingleJob: '/recruitment/jobs/public',
  getPublicCountries: '/recruitment/jobs/public/countries',
  getPublicIndustries: '/recruitment/jobs/public/industries',
  applyJob: '/recruitment/applicants/apply',
  getAppliedJobs: '/recruitment/applicants/applied-jobs',
  submitAssessment: '/recruitment/applicants/my-assessments',
  getAssessmentInterview: '/recruitment/applicants/application',
  getAllOfferLetters: '/recruitment/applicants/offer-letters',
  getOfferLetterDetails: '/recruitment/applicants/offer-letter',
  updateOfferLetterStatus: '/recruitment/applicants/offer-letter',
  updateEmployeeProfile: '/recruitment/applicants',
  aiInterview: '/recruitment/applicants/ai-interview',
};
